/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/**
 * Http specific errors
 */
export class HttpException extends Error {
    public static Name: string = 'HttpException';
    // TODO: type these
    public statusCode: number;

    /**
     * Error class for representing server errors
     * @param code HTTP status code
     * @param message Http status message
     */
    constructor(code: number, message?: string) {
        super(message);
        this.statusCode = code;
        this.name = HttpException.Name;

        // As of Typescript 2.1 if we extend the Error object the prototype must be set explicitly
        // See: https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, HttpException.prototype);
    }
}
